export default "__VITE_ASSET__BgV0DEct__"